import { useMemo } from 'react';
import { AsyncComponentHookResult } from '../../../Types/ComponentHookResult';
import { getGoalExplanations } from '../helpers/getGoalExplanations';
import { useGoal } from './useGoal';

export interface NavigationData {
  tabs: string[];
}

export const useNavigation = (): AsyncComponentHookResult<NavigationData> => {
  const queryResult = useGoal();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const goal = queryResult.data;

    const explanations = getGoalExplanations(goal);

    if (!explanations) {
      return null;
    }

    const tabs = explanations.reduce((acc, { Section }) => {
      if (Section) {
        acc.push(Section);
      }

      return acc;
    }, [] as string[]);

    return {
      tabs,
    };
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
